// =====================================================================
// Per-student hourly-rate helpers.
//
// The "effective rate" for a student is their per-student override when set,
// otherwise their tutor's general hourly rate. A rate change requested by a
// tutor is held in `rate_change_requests` (status='pending') and only takes
// effect — by writing students.hourly_rate_override — once an admin approves.
// =====================================================================

/** Resolve the effective hourly rate: per-student override, else tutor's general rate. */
export function getEffectiveRate(
  hourlyRateOverride: number | null | undefined,
  tutorHourlyRate: number | null | undefined
): number {
  if (hourlyRateOverride !== null && hourlyRateOverride !== undefined) return hourlyRateOverride
  return tutorHourlyRate ?? 0
}

/** Whether the student is currently using a custom (override) rate. */
export function hasRateOverride(hourlyRateOverride: number | null | undefined): boolean {
  return hourlyRateOverride !== null && hourlyRateOverride !== undefined
}

export function formatRate(rate: number | null | undefined): string {
  if (rate === null || rate === undefined) return '—'
  return `$${Number(rate).toFixed(2)}/hr`
}
